// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
// 商品管理
import Goods from '@/views/goods/Goods';
// 商品管理 用户管理
import Index from '@/views/index/Index';
// 商品管理 教练管理
import Coach from '@/views/coach/Coach';
// 产品管理
import Product from '@/views/product/index';
//订单管理
import Order from '@/views/pay/order';
//订单管理
import Topic from '@/views/topic/index';
//习题管理
import Group from '@/views/group/index';
//视频管理
import Video from '@/views/video/index';
//考试秘籍
import Secret from '@/views/secret/index';
//考试秘籍
import Helps from '@/views/helps/index';
//讲师
import Lecturer from '@/views/lecturer/index';
//课程
import Course from '@/views/course/index';
// 图表界面
import statistics from '@/views/charts/statistics';

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/goods/Goods',
            name: '商品管理',
            component: Goods,
            meta: {
                requireAuth: true
            }
        },{
            path: '/index/Index',
            name: '用户管理',
            component: Index,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/coach/Coach',
            name: '教练管理',
            component: Coach,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/product/index',
            name: '教练管理',
            component: Product,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/topic/index',
            name: '习题管理',
            component: Topic,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/group/index',
            name: '习题管理',
            component: Group,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/video/index',
            name: '视频管理',
            component: Video,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/secret/index',
            name: '考试秘籍',
            component: Secret,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/helps/index',
            name: '考试秘籍',
            component: Helps,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/pay/order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/lecturer/index',
            name: '讲师列表',
            component: Lecturer,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/course/index',
            name: '讲师列表',
            component: Course,
            meta: {
                requireAuth: true
            }
        }
    ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js